import { render, staticRenderFns } from "./BaseBFormModal.vue?vue&type=template&id=79b85120&scoped=true"
import script from "./BaseBFormModal.vue?vue&type=script&lang=js"
export * from "./BaseBFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b85120",
  null
  
)

export default component.exports